module.exports = __webpack_public_path__ + "static/design@2x-5c293f41dbc3249fa11a76dcafa67bc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/enterprise/design@2x.png
// module id = 2564
// module chunks = 168707334958949